require('./position');

var MODULE_NAME = 'ui.bootstrap.module.position';

angular.module(MODULE_NAME, ['ui.bootstrap.position']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/position/index-nocss.js
// module id = 175
// module chunks = 0